import React from 'react'
import styled from 'styled-components'

import ClientDetailsHistory from './ClientDetailsHistory'
import AccessPermissions from './AccessPermissions'
import NodeSharing from './NodeSharing'
import { translateWebMessages, commonIcon } from '../../helpers'

const Wrapper = styled.div`
  .item-container {
    height: 50%;
  }
`

const SomeOther = ({ ID, hash, data }) => {
  const { base, keydetailshistory, accessperms, nodesharing } = data

  return (
    <Wrapper className="u-padding-10 u-fluid u-flex u-directionColumn">
      <div className="item-container u-fluid u-flex u-directionColumn u-marginBottom-10">
        <ClientDetailsHistory ID={ID} data={keydetailshistory} />
      </div>

      <div className="item-container u-flex u-fluid u-flexBasis0">
        {/*@ts-ignore*/}
        <AccessPermissions ID={ID} hash={hash} data={accessperms} />

        <NodeSharing nodesharing={nodesharing} NodeID={base.NodeID} />
      </div>
    </Wrapper>
  )
}

SomeOther.config = {
  title: () => translateWebMessages('tb_other'),
  name: 'someother',
  component: SomeOther,
  api: ['base', 'keydetailshistory', { page: 'accessperms', permission: 'VIEW_RL' }, 'nodesharing'],
  icon: commonIcon('216'), // elipsis icon
}

export default SomeOther
